import { useDetailApi } from "../../../swr/useApi";
import { salesService } from "../../api_client";
import type { SaleDetailsDto } from "../../../api";

export function useSaleDetails(
    id: number | null,
    options?: { refreshInterval?: number },
) {
    const valid = id != null && Number.isFinite(id);
    return useDetailApi<SaleDetailsDto>({
        key: valid ? `sale-details-${id}` : null,
        serviceMethod: async () => await salesService.getSaleDetails(id as number),
        options: { refreshInterval: options?.refreshInterval ?? 10_000 },
    });
}
